import { X, Trash2 } from "lucide-react";

const DeleteConfirmModal = ({
  open,
  title = "Delete",
  description = "Are you sure you want to delete this?",
  loading,
  onCancel,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-sm bg-white rounded-xl p-5 animate-fadeIn">

        {/* HEADER */}
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-sm font-semibold">{title}</h3>
          <button onClick={onCancel}>
            <X size={18} />
          </button>
        </div>

        {/* BODY */}
        <p className="text-sm text-gray-600 mb-6">
          {description}
        </p>

        {/* ACTIONS */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm border rounded-lg"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={loading}
            className="flex items-center gap-2 px-4 py-2 text-sm bg-red-500 text-white rounded-lg"
          >
            <Trash2 size={14} />
            {loading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
